import { mdiCodeTags } from '@mdi/js'
import { Icon } from '@mdi/react'
import theme from 'theme_'

import { StyledSoftwareName } from 'features/home/components/HomeSoftware/HomeSoftwareUpdates/styles'

interface SoftwareVersionCellProps {
  version: string
}

export const SoftwareVersionCell = ({ version }: SoftwareVersionCellProps) => (
  <StyledSoftwareName>
    <Icon path={mdiCodeTags} size={1} color={theme.colors.beachGrey} />
    <span>{version}</span>
  </StyledSoftwareName>
)
